export default class LogoUrl {
    constructor() {
        this.logo = document.querySelector(".custom-logo-link");
        this.path = window.location.pathname;
        this.init();
    }

    init() {
        this.setLogoUrl();
    }

    setLogoUrl() {
        if (this.path.startsWith("/hcp/")) {
            this.logo.href = "/hcp/";
        }
    }
}
